module.exports = __webpack_public_path__ + "static/media/music-slash.61445be1.svg";